// ProtectedRoute.js
import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from './AuthContext';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import api from './api';

export default function ProtectedRoute({ routePath }) {
  const { token } = useContext(AuthContext);
  const [allowed, setAllowed] = useState(null); // null = loading, true/false = result
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    let active = true;
    async function check() {
      if (!token) {
        setAllowed(false);
        return;
      }
      try {
        const res = await api.post('/auth/can-access', { routePath }, {headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }})
        console.log("log: can-access", res)
        if (!res.data.active) return;
        setAllowed(!!res.data.allowed);
      } catch (err) {
        if(err.response.data.message === "Invalid or expired token"){
          navigate('/login');
        }
        console.error(err);
        setAllowed(false);
      }
    }
    check();
    return () => { active = false; };
  }, [token, routePath]);

  if (allowed === null) return <div>Loading...</div>;
  if (!token) return <Navigate to="/login" state={{ from: location }} replace />;
  if (!allowed) return <div>Unauthorized to view this page</div>; // or redirect to a 403 page
  return <Outlet />;
}
